"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AutumnProvider_exports = {};
__export(AutumnProvider_exports, {
  AutumnProvider: () => AutumnProvider
});
module.exports = __toCommonJS(AutumnProvider_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_AutumnProvider = require("./client/AutumnProvider");
var import_encryptUtils = require("../utils/encryptUtils");
var import_authPlugin = require("./server/auth/authPlugin");
const AutumnProvider = ({
  customerId,
  customerData,
  authPlugin,
  children,
  components
}) => {
  if (typeof window !== "undefined") {
    throw new Error(
      "AutumnProvider must be used in a server component. It cannot be used in client components."
    );
  }
  let encryptedCustomerId = customerId ? (0, import_encryptUtils.encryptData)(customerId) : void 0;
  if (authPlugin) {
    (0, import_authPlugin.setupAuthPlugin)({
      useUser: true,
      ...authPlugin
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_AutumnProvider.AutumnClientProvider,
    {
      encryptedCustomerId,
      customerData,
      components,
      children
    }
  );
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AutumnProvider
});
